import { Alert, Form, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { retrieveContributors } from "../../redux/actions/contributorActions";
import { retrieveLabels } from "../../redux/actions/labelActions";
import { retrieveAllTracks } from "../../redux/actions/trackActions";
import { RootState } from "../../redux/rootReducer";
import { Actions, ContributorType } from "../../shared/constant";
import { resetClientFilterEditError } from "../../redux/actions/accountActions";

const { Option } = Select;

function FiltersForm({
  mode,
  editData,
  filtersForm,
}: {
  mode: string;
  editData: any;
  filtersForm: any;
}) {
  const dispatch = useDispatch();
  const { allTracks } = useSelector((state: RootState) => state.track);
  const { allLabels } = useSelector((state: RootState) => state.label);
  const { allArtists, allLyricists, allComposers } = useSelector(
    (state: RootState) => state.contributor,
  );
  const { clientFilterEditError } = useSelector(
    (state: RootState) => state.account,
  );
  const [selectedLabelIDs, setSelectedLabelIDs] = useState<string[]>(
    mode === Actions.EDIT ? editData?.display_label : [],
  );

  useEffect(() => {
    if (mode === Actions.EDIT) {
      filtersForm.setFieldsValue({
        labels: editData.display_label,
        artists: editData.display_artist,
        lyricists: editData.display_lyricist,
        composers: editData.display_composer,
        included_tracks: editData.display_included_tracks,
        excluded_tracks: editData.display_excluded_tracks,
      });
    }
  }, [mode]);

  useEffect(() => {
    dispatch(retrieveLabels({ page: "all" }));
    dispatch(retrieveAllTracks({}));
  }, []);

  useEffect(() => {
    dispatch(
      retrieveContributors({
        type: ContributorType.ARTIST,
        page: "all",
        labels: selectedLabelIDs,
      }),
    );
    dispatch(
      retrieveContributors({
        type: ContributorType.LYRICIST,
        page: "all",
        labels: selectedLabelIDs,
      }),
    );
    dispatch(
      retrieveContributors({
        type: ContributorType.COMPOSER,
        page: "all",
        labels: selectedLabelIDs,
      }),
    );
  }, [selectedLabelIDs]);

  const handleLabelChange = (value: string[]) => {
    filtersForm.setFieldsValue({
      artists: [],
      lyricists: [],
      composers: [],
    });
    setSelectedLabelIDs(value);
  };

  const getSelectFieldsID = (name: string, options: any) => {
    return (
      <div>
        <Form.Item
          name={`${name.toLowerCase()}s`}
          label={name}
          className="mb-[6px]"
          initialValue={[]}
        >
          <Select
            mode="multiple"
            placeholder={`Select ${name}`}
            className="w-full"
            allowClear
            // TODO reuse this; used in many places
            filterOption={(inputValue, option) =>
              option?.props.children
                .toString()
                .toLowerCase()
                .includes(inputValue.toLowerCase())
            }
          >
            {options.map((label: any) => (
              <Option key={label.id} value={label.id}>
                {label.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
    );
  };

  const onCloseError = () => {
    dispatch(resetClientFilterEditError());
  };

  return (
    // mb-[30px]
    <div className="mb-[26px]">
      {/*       <div className="bg-bubbles border border-solid border-pale-cyan rounded-sm p-4 mb-4">
        <div className="text-base mb-1">
          Catalog scope will allow you to define which areas of interface can be
          viewed by user.
        </div>
        <div>
          Please note that the fields are not connected. If you specify one
          artist (included on several labels) and one label, you will give
          access to the enitre data for this artist and for this label and not
          only to data for this artist on that particular label.
        </div>
      </div> */}
      {clientFilterEditError && (
        <Alert
          message={
            <div className="text-[15px] text-danger">
              Error: Incomplete payment
            </div>
          }
          description={clientFilterEditError.map((item: string) => (
            <div className="text-sm">{item}</div>
          ))}
          type="error"
          className="mb-4"
          closable
          onClose={onCloseError}
        />
      )}
      <div>
        {/* {getSelectFieldsID("Label", allLabels)} */}
        <Form.Item
          name="labels"
          label="Producer"
          className="mb-[6px]"
          initialValue={[]}
        >
          <Select
            mode="multiple"
            placeholder="Select Producer"
            className="w-full"
            allowClear
            filterOption={(inputValue, option) =>
              option?.props.children
                .toString()
                .toLowerCase()
                .includes(inputValue.toLowerCase())
            }
            onChange={handleLabelChange}
          >
            {allLabels.map((label: any) => (
              <Option key={label.id} value={label.id}>
                {label.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        {getSelectFieldsID("Artist", allArtists)}
        {getSelectFieldsID("Lyricist", allLyricists)}
        {getSelectFieldsID("Composer", allComposers)}
        <Form.Item
          name="included_tracks"
          label="Included Tracks"
          initialValue={[]}
        >
          <Select
            mode="multiple"
            placeholder="Select Track"
            allowClear
            filterOption={(inputValue, option) =>
              option?.props.children
                .toString()
                .toLowerCase()
                .includes(inputValue.toLowerCase())
            }
          >
            {allTracks.map((track: any) => (
              <Option key={track.id} value={track.id}>
                {track.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="excluded_tracks"
          label="Excluded Tracks"
          initialValue={[]}
        >
          <Select
            mode="multiple"
            placeholder="Select Track"
            allowClear
            filterOption={(inputValue, option) =>
              option?.props.children
                .toString()
                .toLowerCase()
                .includes(inputValue.toLowerCase())
            }
          >
            {allTracks.map((track: any) => (
              <Option key={track.id} value={track.id}>
                {track.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
    </div>
  );
}

export default FiltersForm;
